// src/portals/creator/components/ActivityItem.js
import React from "react";
import { UserPlus, Heart, FileCheck } from "lucide-react";

const icons = {
  "New Subscriber": <UserPlus size={16} className="text-purple-600" />,
  "New Tip": <Heart size={16} className="text-pink-600" />,
  "Post Published": <FileCheck size={16} className="text-sky-600" />,
};

const ActivityItem = ({ item }) => {
  return (
    <li className="flex items-start">
      {/* ✨ Slightly reduced margin on mobile */}
      <div className="p-2 bg-slate-100 rounded-full mr-2 sm:mr-3">
        {icons[item.type] || null}
      </div>
      <div>
        <p className="text-sm text-slate-700">{item.text}</p>
        <p className="text-xs text-slate-400">{item.time}</p>
      </div>
    </li>
  );
};

export default ActivityItem;
